import {Layout} from 'components/layout';
import {AdvantagesCarousel} from '../advantages-carousel/advantages-carousel';
import {Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious,} from '../carousel/carousel';

export const Advantages = () => {
  const advantagesList = [
    {
      title: 'Московская прописка',
      image: '/assets/images/png/BIRD_1.jpg',
      description: 'Отсутствие плотной высотной застройки',
    },
    {
      title: '9 минут до станции «Санино» (МЦД-4)',
      image: '/assets/images/png/park.jpg',
      description: '1 минута до парка имени л. н. Толстого',
    },
    {
      title: 'Закрытая территория',
      image: '/assets/images/png/3typebox.jpg',
      description: 'ТРИ типа отделки',
    },
    {
      title: 'система контроля и управления доступом',
      image: '/assets/images/png/parking.png',
      description: 'Подземный паркинг с доступом из лифта ',
    },
    {
      title: 'Безбарьерный вход в подъезды с уровня земли',
      image: '/assets/images/png/monitoring.jpg',
      description: 'Видеонаблюдение и видеодомофоны',
    },
    {
      title: 'Квартиры с антресолью',
      image: '/assets/images/png/keller_1.jpg',
      description: 'Келлеры',
    },
    {
      title: 'Квартиры с собственным входом',
      image: '/assets/images/png/2.jpg',
      description: 'Зеленый двор',
    },
    {
      title: 'Дизайн-проект лифтового холла и внутренней навигации',
      image: '/assets/images/png/cond.png',
      description: 'Корзины для кондиционеров',
    }
  ];

  return (
    <section className="font-open-sans mt-[72px] screen-900:mt-5">
      <AdvantagesCarousel/>
      <div className="relative z-10 bg-plt-secondary/50 -mt-10 screen-900:mt-0 screen-900:bg-plt-white">
        <Layout.Container>
          <div
            id='advantages'
            className="bg-plt-white rounded-[40px] pt-10 pb-[64px] screen-900:rounded-none screen-900:bg-[#F9F9F9] screen-900:pt-6">
            <h3 className="text-center text-[32px] font-bold text-plt-black screen-700:text-lg">
              Преимущества
            </h3>
            <div>
              <Carousel opts={{loop: true, align: 'start'}} className='px-[66px] mt-16'>
                <CarouselContent>
                  {advantagesList.map((advantage, index) => {
                    if (index % 2 === 0) {
                      return (
                        <CarouselItem
                          key={advantage.title + index.toString()}
                          className='basis-1/5 select-none screen-1200:basis-1/4 screen-950:basis-1/3 screen-750:basis-1/2 screen-500:basis-full'>
                          <div className="grid gap-2">
                            <div
                              className="bg-plt-secondary rounded-2xl px-4 py-[10px] flex items-end min-h-20">
                              <p className="font-semibold w-4/5 text-sm text-plt-black uppercase screen-900:text-sm">
                                {advantage.title}
                              </p>
                            </div>
                            <div
                              style={{backgroundImage: `url(${advantage.image})`}}
                              className="min-h-[257px] rounded-2xl flex items-end overflow-hidden bg-cover bg-center"
                            >
                              <div
                                className="w-full h-[120px] pb-[10px] px-4 flex items-end bg-gradient-to-b from-plt-black/0 to-plt-black">
                                <p className="text-plt-white font-semibold uppercase screen-900:text-sm">
                                  {advantage.description}
                                </p>
                              </div>
                            </div>
                          </div>
                        </CarouselItem>
                      );
                    } else {
                      return (
                        <CarouselItem
                          key={advantage.title + index.toString()}
                          className='basis-1/5 select-none screen-1200:basis-1/4 screen-950:basis-1/3 screen-750:basis-1/2 screen-500:basis-full'>
                          <div className="grid gap-2">
                            <div
                              style={{backgroundImage: `url(${advantage.image})`}}
                              className="min-h-[257px] rounded-2xl flex items-end overflow-hidden bg-cover bg-center"
                            >
                              <div
                                className="w-full h-[120px] pb-[10px] px-4 flex items-end bg-gradient-to-b from-plt-black/0 to-plt-black">
                                <p className="text-plt-white font-semibold uppercase screen-900:text-sm">
                                  {advantage.description}
                                </p>
                              </div>
                            </div>
                            <div
                              className="bg-plt-secondary rounded-2xl px-4 py-[10px] flex items-end min-h-20">
                              <p className="font-semibold text-sm text-plt-black uppercase screen-900:text-sm">
                                {advantage.title}
                              </p>
                            </div>
                          </div>
                        </CarouselItem>
                      )
                    }
                  })}
                </CarouselContent>
                <CarouselPrevious className="border-plt-secondary  left-5"/>
                <CarouselNext className="border-plt-secondary  right-5"/>
              </Carousel>
            </div>
          </div>
        </Layout.Container>
      </div>
    </section>
  );
};
